import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { DynamicFormService } from '@ng-dynamic-forms/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DateService } from "../../../../../../@core/functions/date.service";
import { UserInfoService } from "../../../../../../@core/user-info.service";
import { NotificationConfirmationsComponent } from "../../../../../notification/confirmations/notification-confirmations.component";
import { MatDialog } from "@angular/material";
import { MedicalSourcesService } from "../../../../../../@core/medical-sources.service";
import { DialogService } from "../../../../../../../@util/dialog/dialog.service";
import { GlobalSaveService } from "../../../../../../@core/global-save.service";
var MedicalPaymentsFormComponent = /** @class */ (function () {
    function MedicalPaymentsFormComponent(formService, fb, route, dateService, dialog, matDialog, globalSaveService, userInfoService, medicalSourcesService) {
        this.formService = formService;
        this.fb = fb;
        this.route = route;
        this.dateService = dateService;
        this.dialog = dialog;
        this.matDialog = matDialog;
        this.globalSaveService = globalSaveService;
        this.userInfoService = userInfoService;
        this.medicalSourcesService = medicalSourcesService;
        this.backToPaymentsList = new EventEmitter();
        this.paymentsData = [{
                feeCharged: null,
                datePd: null,
                checkNo: null,
                dateBilled: null,
                amountBilled: null,
                datePaid: null
            }];
        this.dataSource = new BehaviorSubject([]);
        this.paymentsFields = this.fb.array([]);
        this.requestsForm = this.fb.group({
            payments: this.paymentsFields
        });
        this.paymentId = '';
    }
    MedicalPaymentsFormComponent.prototype.ngOnDestroy = function () {
    };
    MedicalPaymentsFormComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    MedicalPaymentsFormComponent.prototype.onChange = function ($event) {
    };
    MedicalPaymentsFormComponent.prototype.init = function (payments) {
        var _this = this;
        if (payments == null) {
            this.paymentsData.forEach(function (d) { return _this.addPayment(d, false); });
        }
        else {
            payments.forEach(function (d) { return _this.addPayment(d, false); });
        }
    };
    MedicalPaymentsFormComponent.prototype.addById = function (id) {
        var _this = this;
        this.paymentsFields.clear();
        if (id) {
            this.medicalSourcesService.treatingSourcesFindPayment(id).subscribe(function (data) {
                _this.paymentId = id;
                _this.addPayment(data, false);
            });
        }
        else {
            this.paymentId = '0';
            this.addPayment(null, false);
        }
    };
    MedicalPaymentsFormComponent.prototype.getBtnName = function () {
        if (this.paymentId == '0') {
            return 'Add';
        }
        return 'Update';
    };
    MedicalPaymentsFormComponent.prototype.back = function () {
        this.backToPaymentsList.emit(true);
    };
    MedicalPaymentsFormComponent.prototype.getData = function () {
        var requestsPayments = this.requestsForm.value;
        for (var i = 0; i < requestsPayments.payments.length; i++) {
            requestsPayments.payments[i].datePd = this.dateService.getDateWithoutHours(requestsPayments.payments[i].datePd);
            requestsPayments.payments[i].dateBilled = this.dateService.getDateWithoutHours(requestsPayments.payments[i].dateBilled);
            requestsPayments.payments[i].datePaid = this.dateService.getDateWithoutHours(requestsPayments.payments[i].datePaid);
        }
        return requestsPayments.payments;
    };
    MedicalPaymentsFormComponent.prototype.save = function () {
        var _this = this;
        var requestsPayments = this.requestsForm.value;
        for (var i = 0; i < requestsPayments.payments.length; i++) {
            requestsPayments.payments[i].datePd = this.dateService.getDateWithoutHours(requestsPayments.payments[i].datePd);
            requestsPayments.payments[i].dateBilled = this.dateService.getDateWithoutHours(requestsPayments.payments[i].dateBilled);
            requestsPayments.payments[i].datePaid = this.dateService.getDateWithoutHours(requestsPayments.payments[i].datePaid);
        }
        // console.log(requestsPayments)
        // if (requestsPayments.payments[0].dateBilled === null) {
        // 	this.dialog.show("Please, fill 'Date Claimant Billed' field!", ["ok"]);
        // 	return;
        // } else {
        // 	this.medicalSourcesService.saveTreatingSourcesPayment(this.getSslgId(),this.paymentId,this.getSourceId(), requestsPayments.payments[0]).subscribe(data => {
        // 		this.dialog.show("Information was saved successfully!", ["ok"]);
        //
        // 		this.back();
        // 	});
        // }
        this.medicalSourcesService.saveTreatingSourcesPayment(this.getSslgId(), this.paymentId, this.getSourceId(), requestsPayments.payments[0]).subscribe(function (data) {
            _this.dialog.show("Information was saved successfully!", ["ok"]);
            _this.back();
        });
    };
    MedicalPaymentsFormComponent.prototype.getSourceId = function () {
        return this.route.snapshot.paramMap.get('id');
    };
    MedicalPaymentsFormComponent.prototype.getSslgId = function () {
        return this.route.snapshot.parent.params['sslgId'];
    };
    MedicalPaymentsFormComponent.prototype.addPayment = function (d, noUpdate) {
        var row = this.fb.group({
            'feeCharged': [d && d.feeCharged ? d.feeCharged : null, []],
            'datePd': [d && d.datePd ? new Date(d.datePd) : null, []],
            'checkNo': [d && d.checkNo ? d.checkNo : null, []],
            'dateBilled': [d && d.dateBilled ? new Date(d.dateBilled) : null, []],
            'amountBilled': [d && d.amountBilled ? d.amountBilled : null, []],
            'datePaid': [d && d.datePaid ? new Date(d.datePaid) : null, []],
        });
        this.paymentsFields.push(row);
    };
    MedicalPaymentsFormComponent.prototype.deletePayment = function (index) {
        var _this = this;
        var dialog = this.matDialog.open(NotificationConfirmationsComponent, {
            data: {
                message: "Are you sure you want to delete the payment?"
            }
        });
        dialog.afterClosed().subscribe(function (j) {
            try {
                if (j.status) {
                    _this.paymentsFields.removeAt(index);
                }
            }
            catch (e) {
            }
        });
    };
    MedicalPaymentsFormComponent.prototype.paymentsShowDeleteBtn = function () {
        var count = this.paymentsFields.length;
        if (count == 1) {
            return false;
        }
        return true;
    };
    MedicalPaymentsFormComponent.prototype.clearDate = function (form, field, index) {
        if (this.isViewing()) {
            return;
        }
        this.paymentsFields.controls[index].value[field] = null;
        this.paymentsFields.controls[index].get(field).reset();
    };
    MedicalPaymentsFormComponent.prototype.onBlur = function ($event) {
    };
    MedicalPaymentsFormComponent.prototype.onFocus = function ($event) {
    };
    MedicalPaymentsFormComponent.prototype.isViewing = function () {
        if (this.globalSaveService.getStatusTrue()) {
            return false;
        }
        return true;
    };
    return MedicalPaymentsFormComponent;
}());
export { MedicalPaymentsFormComponent };
